import React from 'react'
// hooks
import { useCurrentTable } from 'hooks/risks'

export const useRowsHeight = ({ groupId, rowId }) => {
  const ref = React.useRef<HTMLDivElement | null>(null)

  const { setRowHeight, removeRowHeight } = useCurrentTable()

  React.useEffect(() => {
    if (!ref.current || !groupId || !rowId) {
      return
    }

    const el = ref.current

    const height = Math.round(el.getBoundingClientRect().height)
    setRowHeight(groupId, rowId, height)

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]

      if (!entry) {
        return
      }

      const nextHeight = Math.round(entry.contentRect.height)

      setRowHeight(groupId, rowId, nextHeight)
    })

    observer.observe(el)

    return () => {
      observer.disconnect()
      removeRowHeight(groupId, rowId)
    }
  }, [groupId, rowId, setRowHeight, removeRowHeight])

  return { ref }
}
